export const FEE_AUDIENCES = [
    "DOMESTIC",
    "INTERNATIONAL",
];
export const INTERNATIONAL_CURRENCY = "USD";
